import { AbstractPmsApiService } from "./abstract.service";
import {Bank} from "../models/bank.model";

/**
 * @class BankService
 * @abstract
 * @extends {AbstractPmsApiService<BankService>}
 */
export class BankService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/banks';
    }

    newModel(attributes) {

        return new Bank(attributes);
    }

     /**
     * @returns {Promise.<Bank>}
     */
    get() {
        return this.http
            .get(this.url(), {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/bank.service.js